/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleDailyTitleReport = {
    properties: {
        title: {
    type: 'string',
    isRequired: true,
},
        totalEmployees: {
    type: 'number',
    isRequired: true,
},
        totalHours: {
    type: 'number',
    isRequired: true,
    format: 'double',
},
        employees: {
    type: 'array',
    contains: {
        type: 'EmployeeScheduleReport',
    },
    isRequired: true,
},
    },
};